module.exports = __webpack_public_path__ + "static/media/sparkle.aa2d0d75.png";